var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyBuyHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.2069C19.6274 23.2069 25 18.2048 25 12.0345C25 5.86412 19.6274 0.862061 13 0.862061C6.37258 0.862061 1 5.86412 1 12.0345C1 18.2048 6.37258 23.2069 13 23.2069Z",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61133 9.38189C6.61133 8.41736 7.6473 7.29208 8.94226 7.29208C10.2372 7.29208 11.2732 8.41736 11.2732 9.38189",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6406 9.38183C14.6406 8.4173 15.6766 7.29202 16.9716 7.29202C18.2665 7.29202 19.3025 8.4173 19.3025 9.38183",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69727 14.1242C6.69727 16.7766 9.54619 18.8664 12.9994 18.8664C16.4527 18.8664 19.3016 16.6962 19.3016 14.1242H6.69727Z",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyBuyHappy);
export default __webpack_public_path__ + "static/media/why-buy-happy.36125f96.svg";
export { ForwardRef as ReactComponent };